import {apiUrl} from "../../../settings";

export const updateMarketingUserManuallyUrl = () => {
    return `${apiUrl}/api/updateMarketingUserManually`
}
